// The engineer's short guide to a SAFed day (Session BDB). Static, readable offline, under one page on a phone.
import { Link } from "react-router-dom";
import { HOWTO_SECTIONS } from "../../lib/safedHowTo";

export function SafedHowItWorksBody() {
  return (
    <div className="space-y-4">
      {HOWTO_SECTIONS.map((s) => (
        <section key={s.heading} aria-label={s.heading}>
          <h2 className="font-heading text-base uppercase tracking-wide text-ele-strong">{s.heading}</h2>
          <ul className="mt-1 list-disc space-y-1 pl-5 text-sm text-ele-body">
            {s.lines.map((l) => (
              <li key={l}>{l}</li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}

export default function SafedHowItWorks() {
  return (
    <main className="mx-auto max-w-xl px-4 py-4">
      <Link to="/engineer" className="text-sm text-ele-muted underline">Back to my jobs</Link>
      <h1 className="mt-2 font-heading text-xl uppercase tracking-wide text-ele-strong">How a SAFed day works</h1>
      <p className="mt-1 text-sm text-ele-body">A short guide. The rules on each screen always win.</p>
      <div className="mt-3">
        <SafedHowItWorksBody />
      </div>
    </main>
  );
}
